

var defines = {
  USER_INFO: "USER_INFO",
  DEVICE_INFO: "DEVICE_INFO",
  RECORD_USER_INFO: "RECORD_USER_INFO",
  CUSTOMER_INFO: "CUSTOMER_INFO",
  CUST_ALL_INFO: "CUST_ALL_INFO",
  SEATSIDE_INFO: "SEATSIDE_INFO",
  IMAGE_INFO: "IMAGE_INFO",
  BUSI_INFO: "BUSI_INFO",
  CUSTOMER_RATING_INFO: "CUSTOMER_RATING_INFO",
  KIDMURL: "KIDMURL",
  VERSION_FLAG: "VERSION_FLAG",
  POSTNAME_DICT: "POSTNAME_DICT",
  ENCRYPT_KEY: "ENCRYPT_KEY",
  F_CUST_ORG_CODE: "F_CUST_ORG_CODE",
  BUSI_SCOPE: "BUSI_SCOPE",
  B_SNO: "B_SNO",
  IS_DOUBLE_RECORD: "IS_DOUBLE_RECORD",
  TASK_CUSTOMER_INFO: "TASK_CUSTOMER_INFO",
  ALL_MENU: "ALL_MENU",
  SYS_DICT_CACHE: "SYS_DICT_CACHE",
  IMG_ERR_PATH: "IMG_ERR_PATH",
  IMG_ADV_DATA: "IMG_ADV_DATA",
  READ_BANK_INFO: "READ_BANK_INFO",
  IS_OPENAGAIN_CHECK_FLAG: "IS_OPENAGAIN_CHECK_FLAG",
  IS_MUST_ASSIGNPERSON: "IS_MUST_ASSIGNPERSON",
  ORG_CURRENT_AGENT: "ORG_CURRENT_AGENT",
  BUSI_COMM_PARAM: "BUSI_COMM_PARAM",
  BUSI_COMM_PARAM_OBJS: "BUSI_COMM_PARAM_OBJS",
  SYS_COMM_PARAM_OBJS: "SYS_COMM_PARAM_OBJS",
  BUSI_PROCESS_DATA: "BUSI_PROCESS_DATA",
  SUITBALY_RESULT: "SUITBALY_RESULT",
  FACE_IMAGE: "FACE_IMAGE",
  OPEN_FUND_ACCT: "OPEN_FUND_ACCT",
  FUND_LIST: "FUND_LIST",
  ALL_FUND_COMPANY: "ALL_FUND_COMPANY",
  ALL_OTC_ORG: "ALL_OTC_ORG",
  OTC_ORG_LIST: "OTC_ORG_LIST",
  NEED_SHOW_EVALUAT_BEFORE_INPAGE: "NEED_SHOW_EVALUAT_BEFORE_INPAGE",
  EVALUAT_ANSWER: "EVALUAT_ANSWER",
  CUSTOMER_FLOW_INFO: "CUSTOMER_FLOW_INFO",
  BUSI_NAME: "BUSI_NAME",
  TODAY_TIME: "TODAY_TIME",
  APPT_SN: "APPT_SN",
  PREVIOUS_BUSI_CODE: "PREVIOUS_BUSI_CODE",
  BUSI_DEF_INFO: "BUSI_DEF_INFO",
  PRE_MODULE_DATA_CACHE: "PRE_MODULE_DATA_CACHE",
  PRE_GROUP_DATA_CACHE: "PRE_GROUP_DATA_CACHE",
  WITNESS_VIDEO_ID: "WITNESS_VIDEO_ID",
  SURVEY_SCORE_CONFIG: "SURVEY_SCORE_CONFIG",
  SURVEY_RISK_DATA: "SURVEY_RISK_DATA",
  IS_POLICE_CHECK: "IS_POLICE_CHECK",
  MATCH_OBJ: "MATCH_OBJ",
  OCR_ID_IMG: "OCR_ID_IMG",
  POLICE_IMG_BASE64: "POLICE_IMG_BASE64",
  ID_FACE_IMG: "ID_FACE_IMG",
  CUST_RECENT_IMG_BASE64: "CUST_RECENT_IMG_BASE64",
  FACE_IMG_NAME: "FACE_IMG_NAME",
  FACE_RECONIZE_SCORE: "FACE_RECONIZE_SCORE",
  ONLY_DUAL_RECORD_IN_BUSI_CODE: "ONLY_DUAL_RECORD_IN_BUSI_CODE",
  ONLY_DUAL_RECORD_ROUTE_INDEX: "ONLY_DUAL_RECORD_ROUTE_INDEX",
  OLD_NAV_ROUTE: "OLD_NAV_ROUTE",
  OLD_BIZ_ROUTE: "OLD_BIZ_ROUTE",
  ACCEPT_TASK_DUAL_BSNO: "ACCEPT_TASK_DUAL_BSNO",
  ACCESS_TOKEN: "ACCESS_TOKEN",
  VTM_USER_INFO: "VTM_USER_INFO",
  TIME_STAMP: "TIME_STAMP",
  HOT_MENU: "HOT_MENU",
  CUACCT_STATUS: "CUACCT_STATUS",
  QSJGDM_CONST: {
    GUOTOU: "100223",
    "100223": "GUOTOU" },
  IMAGE_REJECT_TYPE: "IMAGE_REJECT_TYPE",
  CSDC_REJECT_FLAG: "CSDC_REJECT_FLAG",
  IS_COMPARE_CUST_RECENT_IMAG: "IS_COMPARE_CUST_RECENT_IMAG",
  RECORD_WAY: "RECORD_WAY",
  VTM_VOICE_INPUT: "VTM_VOICE_INPUT",
  GPQQ_CSDC_TIME_FLAG: "GPQQ_CSDC_TIME_FLAG",
  GPQQ_INIT_DATA: "GPQQ_INIT_DATA",
  CSDC_INFO: "CSDC_INFO",
  PRO_B_SNO: "PRO_B_SNO",
  TOKEN: "TOKEN",
  OPEN_ACCTTYPE: "OPEN_ACCTTYPE",
  APPT_STATUS: "APPT_STATUS",
  BIZ_ROUTE_INDEX: "BIZ_ROUTE_INDEX",
  BIZ_ROUTE_TABLE: "BIZ_ROUTE_TABLE",
  BUSI_CODE: "BUSI_CODE",
  USER_TYPE: "USER_TYPE",
  OLD_BIZ_DATA: "OLD_BIZ_DATA",
  OPP_BUSI_DATA: "OPP_BUSI_DATA",
  CAN_CLEAN_DATA: "CAN_CLEAN_DATA",
  MOBILE_LOGIN: "MOBILE_LOGIN",
  LAST_MOBILE_LOGIN: "MOBILE_LOGIN" };

var plugin = {
  install: function install(Vue) {
    Vue.definecfg = defines;

    Vue.prototype.$definecfg = defines;
  },

  $definecfg: defines
};

export default plugin;
export var install = plugin.install;


//////////////////
// WEBPACK FOOTER
// ./src/config/defineConfig.js
// module id = 33
// module chunks = 2